import { nostojs } from "./api"
import settings from "@/core/settings"

function updateRecommendationsOnSkuSelection() {
  const parameters = new URLSearchParams(window.location.search)
  if (parameters.has("variant")) {
    nostojs(api => api.loadRecommendations())
  }
}

export default function init(window: Window) {
  nostojs(api => {
    api.internal.modifySettings({ skuParam: "variant" })
  })
  const testRun = window.nostoab?.settings?.shopifySkuSelectionListener
  if (settings.shopifySkuSelectionListener || testRun) {
    const delayMillis = testRun ? 10 : 500
    // store url on load
    let currentPage = window.document.location.href
    // listen for changes
    setInterval(function () {
      if (currentPage !== window.document.location.href) {
        // page has changed, set new page as 'current'
        currentPage = window.document.location.href
        updateRecommendationsOnSkuSelection()
      }
    }, delayMillis)
  }
}
